<template>
  <section>
    <w-add-button
      v-if="!hasDevice"
      @click="openDeviceDialog()"
    />

    <w-edit-button
      v-else
      @click="openDeviceDialog()"
    >
      <template #tooltip>
        {{ $t('Devices.sentences.editDevice') }}
      </template>
    </w-edit-button>

    <AddEditDeviceDialog ref="deviceDialog" />
  </section>
</template>
<script>

import formUtils from '@/utils/form-utils';
import AddEditDeviceDialog from '../../../../workflow/workflow_action_types/device_initial_assessment/dialogs/AddEditDeviceDialog';
import cloneDeep from 'lodash/cloneDeep';
import staticData from '@/mixins/api_data/static-data-mixin';
import dataMixin from '@/mixins/data-mixin';
import deviceService from '@/services/device-service';

export default {
  name: 'DeviceAddEditDeviceWrapper',
  components: {
    AddEditDeviceDialog,
  },
  props: {
    value: { type: Object },
    customOpenDeviceDialog: {
      type: Function,
    },
  },
  mixins: [
    staticData('deviceTypes', 'devices/types'),
    dataMixin('deviceCopyInEdit', 'transientData.deviceCopyInEdit'),
  ],
  computed: {
    hasDevice() {
      return this.internalValue?.id != undefined;
    },
    isSavedDeviceCopy() {
      return this.internalValue.data?.derivedFrom != undefined;
    },
    isSavedDevice() {
      return (
        this.internalValue?.id != undefined &&
        !formUtils.isNewFormId(this.internalValue?.id)
      );
    },
    internalValue: {
      get() {
        return this.value;
      },
      set(val) {
        this.$emit('input', val);
      },
    },
  },
  methods: {
    async openDeviceDialog() {
      if (this.customOpenDeviceDialog) {
        this.customOpenDeviceDialog();
        return;
      }
      if (!this.internalValue || !this.internalValue.id) {
        let uuid = formUtils.createNewIdentifier();
        this.internalValue = {
          id: undefined,
          uuid: uuid,
        };
        const deviceTypeId = this.deviceTypes.find(
          (item) => item.data.label === 'Kundengerät'
        )?.id;

        this.deviceCopyInEdit = {
          manufacturedYear: new Date().getFullYear(),
          manufacturedMonth: '00',
          type: { id: deviceTypeId },
          product: { id: this.productId },
        };
      } else {
        const response = await deviceService.loadData(this.internalValue.id);
        this.deviceCopyInEdit = cloneDeep(response.data.data);
      }

      this.$refs.deviceDialog
        .open(this.internalValue?.id)
        .then((response) => {
          let uuid = formUtils.createNewIdentifier();
          let editedVal = {
            id: String(response ?? this.internalValue?.id),
            uuid: this.internalValue?.uuid ?? uuid,
            data: this.deviceCopyInEdit,
          };
          this.internalValue = editedVal;
        })
        .catch(() => {
          if (!this.isSavedDeviceCopy && !this.isSavedDevice)
            this.internalValue = undefined;
        });
    },
  },
};
</script>
